import React from "react";
import {
  FaEthereum,
  FaShieldAlt,
  FaChartLine,
  FaCoins,
  FaShoppingCart,
  FaLayerGroup,
  FaExchangeAlt
} from "react-icons/fa";

function ServiceCard({ icon: Icon, title, description }) {
  return (
    <div className="col-xl-3 col-lg-6 col-md-6 mb-30 service-five-single">
      <div className="service-style-five-item">
        <div className="pb-5" style={{ fontSize: "50px", color: "#4a90e2" }}>
          <Icon />
        </div>
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
    </div>
  );
}

function XeerBSC() {
  const services = [
    {
      title: "BSC DApp Development",
      description: "We build fast, efficient decentralized applications on BSC, delivering seamless user experiences with optimized performance for DeFi, NFT, and gaming platforms.",
      icon: FaEthereum,
    },
    {
      title: "Smart Contract Development and Audit",
      description: "Our team develops secure, reliable smart contracts on BSC and conducts thorough audits to safeguard your project from potential vulnerabilities.",
      icon: FaShieldAlt,
    },
    {
      title: "DeFi Platform Development",
      description: "Xeer Technology creates cutting-edge DeFi solutions on BSC, including lending platforms, yield farming, and staking applications, with a focus on low fees and high-speed transactions.",
      icon: FaChartLine,
    },
    {
      title: "BSC Token Development (BEP-20)",
      description: "Launch your own BEP-20 tokens on BSC, fully customized to your project’s needs with features like token staking, liquidity pools, and burn mechanisms.",
      icon: FaCoins,
    },
    {
      title: "NFT Marketplace Development",
      description: "We design and develop NFT marketplaces on BSC, enabling users to trade, mint, and manage NFTs with cost-effective, high-speed transactions.",
      icon: FaShoppingCart,
    },
    {
      title: "Cross-Chain Solutions",
      description: "Xeer specializes in cross-chain solutions to enhance asset interoperability, ensuring your project seamlessly integrates with other blockchains like Ethereum, Polygon, and more.",
      icon: FaLayerGroup,
    },
    {
      title: "Exchange Development",
      description: "Our expertise in building secure, high-performance crypto exchanges on BSC allows for efficient trading, seamless integration with DeFi protocols, and support for multi-chain transactions.",
      icon: FaExchangeAlt,
    },
  ];

  return (
    <div className="services-style-five-area default-padding bottom-less">
      <div className="container">
        <div className="left-heading">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <h4 className="sub-title">Xeer Features</h4>
              <div className="right">
                <h2 className="title">
                  Xeer's Binance Smart Chain Development Services
                </h2>
                <p>
                  Xeer Technology provides comprehensive development services for projects seeking to harness the benefits of Binance Smart Chain. Our experienced blockchain developers specialize in designing custom solutions tailored to your specific business goals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="services-style-five-items">
          <div className="row">
            {services.map((service, index) => (
              <ServiceCard key={index} {...service} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default XeerBSC;